// Static placeholder content. Real content will replace these later.

export const TRACKS = [
  { n: "01", title: "Latuya Bay", year: "2026", featured: true, yt: "AYKu9pf1AFM" },
  { n: "02", title: "Rockstar", year: "2026", featured: false, yt: "lompKyjwb3I" },
  { n: "03", title: "Sex You Up", year: "2026", featured: false, yt: null },
  { n: "04", title: "Revenant", year: "2026", featured: true, yt: "XwYKfHYA01E" },
  { n: "05", title: "Omerta", year: "2026", featured: false, yt: null },
  { n: "06", title: "Motion", year: "2026", featured: false, yt: "sKNGB9x3trw" },
  { n: "07", title: "Don't Leave", year: "2024", featured: false, yt: null },
  { n: "08", title: "Beauty & a Beast", year: "2024", featured: true, yt: "HAizb5mEQl0" },
  { n: "09", title: "Money Tonight", year: "2024", featured: false, yt: "lwWAeg4D7pQ" },
  { n: "10", title: "Young Nigga", year: "2023", featured: false, yt: null },
];

export const PRESS = [
  { quote: "Cassius Grate doesn't make songs — he summons weather.", source: "Rolling Stone" },
  { quote: "A tsunami of sound dressed in cinematic gold.", source: "Pitchfork" },
  { quote: "Pop, rap, and R&B collapse into one majestic tsunami.", source: "Billboard" },
  { quote: "The most cinematic American voice of the decade.", source: "The FADER" },
];

export const STATS = [
  { value: "1.2B+", label: "Streams" },
  { value: "47", label: "Cities Touring" },
  { value: "1", label: "Platinum Plaque" },
  { value: "TBA", label: "Grammy Wins" },
];

export const SOCIALS = [
  { name: "Instagram", url: "#" },
  { name: "TikTok", url: "#" },
  { name: "YouTube", url: "#" },
  { name: "Spotify", url: "#" },
  { name: "Apple Music", url: "#" },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/312408bf-e8ec-4195-89d0-93c5f285c40e/images/4e2aecfaecebb19e19312bdebcd97818702c85deaba999684d14e486ced611e4.png",
  tsunamiBg: "https://static.prod-images.emergentagent.com/jobs/312408bf-e8ec-4195-89d0-93c5f285c40e/images/85f159e26bff3ed50ba26b2278af597b34238c7103f3eb5596f063ef42c5bae6.png",
  tourBg: "https://static.prod-images.emergentagent.com/jobs/312408bf-e8ec-4195-89d0-93c5f285c40e/images/3e42dd6c4f203fba0b1ef79037a49437d81ccaa8123dea63f95785f7d67e005d.png",
  hoodie: "https://static.prod-images.emergentagent.com/jobs/312408bf-e8ec-4195-89d0-93c5f285c40e/images/0be3ec3109414baad420561cc7f5b055d3491c2374c3e59632fe392124f4c7e2.png",
  vinyl: "https://static.prod-images.emergentagent.com/jobs/312408bf-e8ec-4195-89d0-93c5f285c40e/images/e36b3a903579a99d96214692673c699bcfcc91cef57233d960af28dafe5af052.png",
};
